export default {
  //存储数据
  state: {
    isCollapse: false,
    currentMenu: null,
    tabsList: [],
  },
  //调用方法
  mutations: {
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse;
    },
    //选择标签 选择面包屑
    selectMenu(state, val) {
      console.log(val, "-----------");
      state.currentMenu = val;
      //如果等于-1说明tabsList不存在那么插入，否则什么都不做
      let result = state.tabsList.findIndex((item) => item.name === val.name);
      result === -1 ? state.tabsList.unshift(val) : "";
    },
    //关闭标签
    closeTab(state, val) {
      let result = state.tabsList.findIndex((item) => item.name === val.name);
      state.tabsList.splice(result, 1);
    },
    // 全部取消防止登录或者再次登录数据还在
    closeAllTab(state){
        state.tabsList=[]
    }
  },
  actions: {},
};
